import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import Box from "@mui/material/Box";

// ==========================================
// 1. IMPORTS DE COMPONENTES POR FEATURE
// ==========================================

// Landing Pacientes
import HomeCliente from "../features/landing-pacientes/HomePacientes";
import SearchResults from "../features/landing-pacientes/BuscadorProfesionales";

// Landing Profesionales & Registro
import Landing from "../features/landing-profesionales/Landing.jsx";
import RegistrationFlow from "../features/registro/Registracion";
import Profesionales from "../features/profesionales/perfil-publico/Profesional";

// Referidos
import LandingReferidos from "../features/referidos-landing/LandingReferidos";

// Agendamiento (Flujo Principal)
import Calendario from "../features/profesionales/agendamiento/Calendario";
import DatosPaciente from "../features/profesionales/agendamiento/DatosPaciente";
import Ingresada from "../features/profesionales/agendamiento/Ingresada";

// Pagos (Webpay & Transbank)
import Payment from "../features/profesionales/agendamiento_pagos/Payment";
import PaymentTransbank from "../features/profesionales/agendamiento_pagos/PaymentTransbank";

// Transferencias Bancarias
import RutPagador from "../features/profesionales/agendamiento_transferencias/RutPagador";
import DatosTransferencia from "../features/profesionales/agendamiento_transferencias/DatosTransferencia";
import ValidadorTransferencia from "../features/profesionales/agendamiento_transferencias/Validacion";
import ExitoTransferencia from "../features/profesionales/agendamiento_transferencias/ExitoTransferencia";

// Postagendamiento (Gestión, Links de Pago, Formularios)
import GestionSesion from "../features/profesionales/postagendamiento/gestion_sesion/GestionSesion";
import LinkdePago from "../features/profesionales/postagendamiento/link_de_pago/LinkdePago";
import LinkPagoValidar from "../features/profesionales/postagendamiento/link_de_pago/LinkPagoValidar";
import FormularioRespuesta from "../features/profesionales/postagendamiento/formulario/FormularioRespuesta";
import EvaluacionForm from "../features/profesionales/postagendamiento/evaluacion/Evaluacion";

// Módulos Auxiliares (Contenidos, Eventos, Servicios)
import ContenidoDetalle from "../features/profesionales/contenido/ContenidoDetalle";
import ContenidoComprar from "../features/profesionales/contenido/ContenidoComprar";
import ContenidoStatus from "../features/profesionales/contenido/ContenidoStatus";
import ContenidoAcceder from "../features/profesionales/contenido/ContenidoAcceder";

import EventoDetalle from "../features/profesionales/eventos/EventoDetalle";
import EventoComprar from "../features/profesionales/eventos/EventoComprar";
import EventoStatus from "../features/profesionales/eventos/EventoStatus";

import ServicioDetalle from "../features/profesionales/servicios/ServicioDetalle";

// Páginas Legales
import PoliticaPrivacidad from "../features/legal/PoliticaPrivacidad";

// Tools (uso interno, no indexadas)
import VerificadorAdipa from "../features/tools/VerificadorAdipa";
import TerminosCondiciones from "../features/legal/TerminosCondiciones";

function Routes() {
  return (
    <RouterRoutes>
      {/* ==========================================
          A. RUTAS PÚBLICAS Y LANDING PAGES
          ========================================== */}
      <Route path="/" element={<HomeCliente />} />
      <Route path="/busqueda" element={<SearchResults />} />
      <Route path="/pro" element={<Box sx={{ overflowX: "hidden" }}><Landing /></Box>} />
      <Route path="/pro/registro" element={<Box sx={{ overflowX: "hidden" }}><RegistrationFlow /></Box>} />
      <Route path="/ref/:slug" element={<Box sx={{ overflowX: "hidden" }}><LandingReferidos /></Box>} />

      {/* ==========================================
          B. RUTAS FRONTALES DE AGENDAMIENTO
             (Deben ir ANTES de las dinámicas de perfil)
          ========================================== */}
      <Route path="/pro/perfil/calendario" element={<Calendario />} />
      <Route path="/pro/perfil/datos" element={<DatosPaciente />} />
      <Route path="/pro/perfil/exito" element={<Ingresada />} />

      {/* ==========================================
          C. RUTAS DE COMPRA Y PAGOS WEB
          ========================================== */}
      <Route path="/payment" element={<Payment />} />
      <Route path="/agenda/validar-pago-transbank" element={<PaymentTransbank />} />

      {/* Transferencias manuales */}
      <Route path="/pro/transferencia/rut_pagador" element={<RutPagador />} />
      <Route path="/pro/transferencia/datos_transferencia" element={<DatosTransferencia />} />
      <Route path="/pro/transferencia/validador" element={<ValidadorTransferencia />} />
      <Route path="/pro/perfil/exito-transferencia" element={<ExitoTransferencia />} />

      {/* Links de Pago Directos (Gestión de deuda) */}
      <Route path="/linkdepago/:id_cobro_sesion" element={<LinkdePago />} />
      <Route path="/validarlinkdepago" element={<LinkPagoValidar />} />

      {/* ==========================================
          D. GESTIÓN DE CITAS (POSTAGENDAMIENTO)
          ========================================== */}
      <Route path="/sesiones/confirmar/:sesion_link" element={<GestionSesion />} />
      <Route path="/sesiones/reagendar/:sesion_link" element={<GestionSesion />} />
      <Route path="/sesiones/cancelar/:sesion_link" element={<GestionSesion />} />
      <Route path="/sesiones/reagendarocancelar/:sesion_link" element={<GestionSesion />} />
      <Route path="/sesiones/cekib/:sesion_link" element={<GestionSesion />} />

      {/* ==========================================
          E. MÓDULOS DE PROFESIONALES (E-Commerce)
          ========================================== */}
      {/* Contenido Digital */}
      <Route path="/contenido/checkout" element={<ContenidoComprar />} />
      <Route path="/contenido/checkout/status" element={<ContenidoStatus />} />

      {/* Eventos Presenciales/Online */}
      <Route path="/evento/checkout" element={<EventoComprar />} />
      <Route path="/evento/checkout/status" element={<EventoStatus />} />

      {/* ==========================================
          F. PÁGINAS LEGALES
          ========================================== */}
      <Route path="/politicadeprivacidad" element={<PoliticaPrivacidad />} />
      <Route path="/terminosycondiciones" element={<TerminosCondiciones />} />

      {/* ==========================================
          H. TOOLS INTERNAS (no indexadas, no públicas)
          ========================================== */}
      <Route path="/tools/adipa" element={<VerificadorAdipa />} />

      {/* ==========================================
          G. RUTAS DINÁMICAS (PARÁMETROS)
             *Importante que vayan al final para que 
             no tapen a rutas estáticas anidadas.
          ========================================== */}
      {/* Perfil Público (La ruta más genérica) */}
      <Route path="/pro/:profesionalNombre" element={<Profesionales />} />

      {/* Elementos Sueltos de Venta Dinánicos */}
      <Route path="/servicio/:servicio_link" element={<ServicioDetalle />} />
      <Route path="/contenido/:id_contenido" element={<ContenidoDetalle />} />
      <Route path="/contenido/acceder/:id_venta" element={<ContenidoAcceder />} />
      <Route path="/evento/:evento_link" element={<EventoDetalle />} />

      {/* Formularios Clínicos enviados a los pacientes */}
      <Route path="/pro/formulario/:id" element={<FormularioRespuesta />} />
      <Route path="/pro/evaluacion/:id" element={<EvaluacionForm />} />

      {/* ==========================================
          Z. RUTAS 404 (FALLBACK)
          ========================================== */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
}

export default Routes;
